<script lang="ts">
  import { getPageCategory } from '../../pageCategory'
  import type { SerializedTagsBlock } from '../../types'
  import TagPill from '../TagPill.svelte'
  import { getI18n } from '../../i18n'

  let { block }: { block: SerializedTagsBlock } = $props()

  const pageCategory = getPageCategory()
  const i18n = getI18n()
</script>

<ul class="tags-block">
  {#each block.tags as tag (tag)}
    <TagPill text={i18n.t(`tags.${tag}`)} variant={pageCategory.variant} />
  {/each}
</ul>

<style>
  .tags-block {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-5);
    list-style: none;
    padding: 0;
  }
</style>
